import { api } from '../index';

export const send = data => api.post('/euler-hermes', data);
